'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const ThumbnailsHeroImagesSlidesContainer = renderWithRef('ThumbnailsHeroImagesSlidesContainer', null, (t, o)=>{
    var { children: n } = t;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-thumbnails-hero-images-slides'
        ],
        props: _object_without_properties(t, [
            "children"
        ]),
        children: n
    });
});

export { ThumbnailsHeroImagesSlidesContainer };
